import { createContext } from 'react';

import type { CheckoutProviderContext } from './checkout-provider.types';

const CheckoutContext = createContext<CheckoutProviderContext | undefined>(undefined);

export { CheckoutContext };
